export class TwoFABackupCodeModel {
  EmpId: number;
  BackupCode: string;
}
